/* EL LIENZO 3D DENTRO DE LA GALERÍA DE LA FICHA — Cuadros Splash (20 sep 2026)

   QUÉ HACE
   Añade el cuadro en 3D como ÚLTIMA diapositiva de la galería del producto,
   girable con el ratón, igual que el de la portada. Hasta hoy el 3D existía
   pero vivía detrás del botón «Ver en 3D», que abre una ventana aparte:
   había que saber que estaba ahí. Gabriel lo pidió el 20 sep 2026.

   DE DÓNDE SACA LAS COSAS
   No repite datos: lee el bloque `[data-cs3d]` que ya pinta
   product-canvas-3d.liquid (la obra limpia, la profundidad del bastidor, el
   relieve del gel y el brillo). Si ese bloque no está, no hay 3D que montar
   y esto no hace nada.

   EL TAMAÑO LO MANDA LA TALLA ELEGIDA, y cambia con ella: un 150x100 y un
   40x50 no son el mismo objeto. Al cambiar de talla se rehace el modelo.

   CUÁNDO SE MONTA
   Solo cuando la diapositiva del 3D está a punto de verse. Un WebGL vivo y
   un modelo de varios MB no los paga quien nunca llega a esa foto.

   SI ALGO FALLA no pasa nada: la diapositiva se quita de en medio y la
   galería se queda con las fotos, que es lo que había ayer.

   EL MÓVIL (6 oct 2026). Gabriel, en un Android: «recuadro gris vacío».
   Medido con un móvil simulado en 4G: desde que llegas a la diapositiva
   hasta que sale el cuadro pasaban ~3 s sin ninguna señal de que algo
   cargaba. Y peor: «esta-puesto» se ponía nada más dar el modelo, no cuando
   el visor lo tenía listo, así que si el visor fallaba el recuadro se
   quedaba gris para siempre. Ahora:
   - en un carrusel (el móvil), se prepara en cuanto la página termina de
     cargar o se empieza a deslizar, no al llegar a la última foto;
   - mientras se prepara, el recuadro dice «Preparando el cuadro en 3D»
     (lo pinta cs-lienzo-galeria.css);
   - solo se enciende cuando el visor avisa de que el modelo está cargado,
     y si avisa de error, no hay WebGL o no termina, la diapositiva se quita.
   Para ver en un móvil por qué no sale, abrir la ficha con ?diag3d=1: en
   vez de quitar la diapositiva, escribe el motivo dentro.
*/
(function () {
  var URL_VISOR = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
  var DIAG = /[?&#]diag3d\b/.test(location.search + location.hash);

  /* model-viewer 4 va sobre Three.js moderno, que ya solo dibuja con WebGL 2.
     Se pregunta antes de bajar nada: sin WebGL 2 no hay 3D que valga. */
  function hayWebGL() {
    try {
      var gl = document.createElement('canvas').getContext('webgl2');
      if (!gl) return false;
      var x = gl.getExtension('WEBGL_lose_context');
      if (x) x.loseContext();   // la prueba no se queda con un contexto
      return true;
    } catch (e) {
      return false;
    }
  }

  function cargarModelViewer() {
    if (window.__cs3dMV) return window.__cs3dMV;
    window.__cs3dMV = new Promise(function (res, rej) {
      if (window.customElements && customElements.get('model-viewer')) return res();
      var s = document.createElement('script');
      s.type = 'module';
      s.src = URL_VISOR;
      s.onload = function () { res(); };
      s.onerror = function () { rej(new Error('no llegó model-viewer')); };
      document.head.appendChild(s);
    });
    return window.__cs3dMV;
  }

  /* Espera a que canvas-3d.js registre su API. Suele estar —lo carga el
     bloque de los botones «Ver en 3D»— pero va con `defer`, así que puede no
     haber corrido todavía. Y si ese bloque no estuviera en la ficha, se trae
     el guion aquí: la etiqueta <script src> la respeta el minificador de
     Shopify, que es lo que NO hace con un import() dinámico (trampa 29). */
  function conApi(urlCanvas3d) {
    return new Promise(function (res, rej) {
      if (window.CuadrosSplash3D) return res(window.CuadrosSplash3D);
      if (urlCanvas3d && !document.querySelector('script[src*="canvas-3d.js"]')) {
        var s = document.createElement('script');
        s.src = urlCanvas3d;
        s.defer = true;
        document.head.appendChild(s);
      }
      var intentos = 0;
      var reloj = setInterval(function () {
        if (window.CuadrosSplash3D) {
          clearInterval(reloj);
          return res(window.CuadrosSplash3D);
        }
        /* 15 s y no 4: en el móvil esto ya arranca con la página recién
           cargada, y con mala cobertura 4 s no daban ni para el guion. */
        if (++intentos > 150) {
          clearInterval(reloj);
          rej(new Error('canvas-3d.js no registró su API'));
        }
      }, 100);
    });
  }

  function montar(caja) {
    if (caja.dataset.montado === '1') return;
    caja.dataset.montado = '1';

    var seccion = caja.closest('[id^="shopify-section"]') || document;
    /* La fuente de verdad es el bloque de los botones: si alguien cambia ahí
       el relieve o el brillo, esto va detrás sin tocar nada. */
    var ajustes = seccion.querySelector('[data-cs3d]');
    var urlObra = (ajustes && ajustes.dataset.obra) || caja.dataset.obra || '';
    if (!urlObra) return quitar(caja, 'la ficha no trae la foto de la obra');
    if (!hayWebGL()) return quitar(caja, 'este navegador no tiene WebGL 2');

    var api = null;
    var obra = null;        // bytes de la textura
    var urlViva = '';       // el blob del GLB actual, para poder soltarlo
    var mv = null;
    var ultimaTalla = '';
    var relojCarga = 0;     // el plazo que se le da al visor para cargar

    function quitarModelo() {
      if (urlViva) {
        URL.revokeObjectURL(urlViva);
        urlViva = '';
      }
    }

    /* La talla elegida, mirando TODA la sección: en Dawn el selector de
       variantes vive FUERA del <form> (trampa 2 del proyecto). */
    function tallaElegida() {
      var textos = [];
      seccion.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
        textos.push(i.value || '');
        var l = i.labels && i.labels[0];
        if (l) textos.push(l.textContent || '');
      });
      seccion.querySelectorAll('select').forEach(function (s) {
        var o = s.options[s.selectedIndex];
        if (o) textos.push(o.value || o.textContent || '');
      });
      for (var i = 0; i < textos.length; i++) {
        var m = api.medirTalla(textos[i]);
        if (m) return { medida: m, clave: textos[i] };
      }
      return null;
    }

    /* Se guarda la PROMESA y no solo el resultado: la descarga empieza al
       montar, a la vez que el visor, y pintar() se engancha a la misma en
       vez de pedir la foto otra vez. */
    var bajando = null;
    function bajarObra() {
      if (obra) return Promise.resolve(obra);
      if (bajando) return bajando;
      bajando = fetch(urlObra, { mode: 'cors' }).then(function (r) {
        if (!r.ok) throw new Error('obra ' + r.status);
        var mime = (r.headers.get('content-type') || 'image/jpeg').split(';')[0];
        return r.arrayBuffer().then(function (b) {
          obra = { datos: new Uint8Array(b), mime: mime };
          return obra;
        });
      });
      return bajando;
    }

    /* En el PC el cuadro entra al 90 % de lo que llenaba antes (Gabriel,
       24 sep 2026): en el marco grande de escritorio se veía demasiado
       encima. El radio va al revés que el tamaño: 105 / 0,9 = 117. En el
       móvil se queda como estaba. */
    var RADIO_INICIAL = window.matchMedia('(min-width: 990px)').matches ? 117 : 105;

    /* EL VISITANTE TOMA EL MANDO. Solo retira el recado de "gíralo" (ver
       cs-lienzo-galeria.css): el cuadro nunca gira solo (ver más abajo, al
       montar el <model-viewer>), así que aquí ya no hay nada que parar. */
    var conMando = false;
    function tomarElMando() {
      if (conMando) return;
      conMando = true;
      caja.classList.add('con-mando');
    }

    /* EL ZOOM SE LLEVA EN PORCENTAJE, NO EN METROS, y esto no es un capricho.
       `getCameraOrbit()` devuelve el radio en metros, pero solo cuando la
       camara ya se ha resuelto contra el modelo — o sea, despues de pintar
       un fotograma. Antes de eso da un valor que no sirve (medido: -0,66 m,
       negativo), y una cuenta sobre eso manda la camara a cualquier parte.
       El porcentaje, en cambio, lo resuelve model-viewer: 100 % es la
       distancia a la que el cuadro entra justo en el marco, y vale igual
       para un 40x50 que para un 150x100.

       De theta y phi sí se fia: esos salen bien desde el primer momento, y
       son los que conservan el giro que le haya dado el visitante. */
    var CERCA = 40;   // lo mas cerca que llevan los botones
    var LEJOS = 190;
    var zoomAhora = RADIO_INICIAL;

    function zoom(paso) {
      tomarElMando();
      zoomAhora = Math.max(CERCA, Math.min(LEJOS, zoomAhora * paso));
      var o = mv.getCameraOrbit && mv.getCameraOrbit();
      var th = o ? o.theta + 'rad' : '-22deg';
      var ph = o ? o.phi + 'rad' : '80deg';
      mv.cameraOrbit = th + ' ' + ph + ' ' + zoomAhora + '%';
    }

    function alSitio() {
      zoomAhora = RADIO_INICIAL;
      mv.cameraOrbit = '-22deg 80deg ' + RADIO_INICIAL + '%';
    }

    function armarMandos() {
      mv.addEventListener('pointerdown', tomarElMando);

      /* LA RUEDA NO SE ENCIENDE NUNCA, y esta es la segunda version de esta
         decision. La primera la encendia al pulsar dentro del cuadro y la
         apagaba al salir el raton; Gabriel la probo y dijo lo obvio: «la
         rueda del raton se mezcla con el scroll». Y es que no hay termino
         medio — mientras el zoom esta activo, model-viewer se queda el
         evento y la pagina NO baja. En un visor que ocupa media ficha, eso
         gana siempre a la comodidad de acercar con la rueda.

         Se acerca con los botones y con doble clic. La rueda, a bajar. */
      mv.addEventListener('dblclick', function (e) {
        e.preventDefault();
        /* Doble clic: si ya esta cerca, vuelve; si no, se acerca de golpe.
           Un solo gesto para ir y volver, que es como funciona un mapa. */
        if (zoomAhora <= CERCA * 1.25) alSitio();
        else zoom(CERCA / zoomAhora);
      });

      var mandos = caja.querySelector('[data-cs3d-mandos]');
      if (!mandos) return;
      mandos.hidden = false;
      mandos.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        if (b.dataset.cs3dZoom === 'mas') zoom(0.72);
        else if (b.dataset.cs3dZoom === 'menos') zoom(1 / 0.72);
        else if (b.dataset.cs3dZoom === 'volver') alSitio();
        /* Con los botones el zoom no necesita la rueda, asi que se puede
           usar sin haber tocado el cuadro — pero el giro automatico si se
           para: si no, se aleja solo de lo que acabas de acercar. */
        tomarElMando();
      });
    }

    function pintar() {
      var t = tallaElegida();
      if (!t) return;
      if (t.clave === ultimaTalla && mv && mv.getAttribute('src')) return;
      ultimaTalla = t.clave;

      var fondo = parseFloat((ajustes && ajustes.dataset.profundidad) || '') || api.PROFUNDIDAD_M;
      return bajarObra().then(function (o) {
        var bytes = api.construirGLB(t.medida.ancho, t.medida.alto, fondo, o.datos, o.mime);
        quitarModelo();
        urlViva = URL.createObjectURL(new Blob([bytes], { type: 'model/gltf-binary' }));
        mv.setAttribute('src', urlViva);
        /* Modelo nuevo, camara a su sitio: el encuadre de antes era de OTRO
           cuadro. */
        alSitio();
        /* Encender lo hace el 'load' del visor, no esto. Si en 15 s el visor
           no ha dicho nada, no lo va a decir: fuera, antes que gris. */
        if (!caja.classList.contains('esta-puesto')) {
          clearTimeout(relojCarga);
          relojCarga = setTimeout(function () {
            if (!caja.classList.contains('esta-puesto')) quitar(caja, 'el visor no terminó de cargar el modelo');
          }, 15000);
        }
      });
    }

    conApi(caja.dataset.canvas3d)
      .then(function (a) {
        api = a;
        if (!tallaElegida()) throw new Error('la talla elegida no es una medida');
        /* EL VISOR Y LA FOTO DE LA OBRA, A LA VEZ y no una detrás de otra:
           en un 4G eso era más de un segundo de espera. Van después de mirar
           la talla para no bajar nada en las fichas sin 3D (las de varias
           piezas). El .catch vacío solo evita el aviso de promesa sin
           atender: si la foto falla, el error sale en pintar(). */
        bajarObra().catch(function () {});
        return cargarModelViewer();
      })
      .then(function () {
        mv = document.createElement('model-viewer');
        mv.setAttribute('alt', caja.dataset.alt || 'El cuadro en 3D');
        mv.setAttribute('camera-controls', '');
        /* EL ZOOM DE LA RUEDA, APAGADO Y PARA SIEMPRE. Con el encendido,
           model-viewer se queda el evento de la rueda y la PAGINA DEJA DE
           BAJAR mientras el puntero esta encima del cuadro. En la ficha el
           visor ocupa media pantalla: eso es quedarse atrapado.
           Para acercar estan los botones y el doble clic (ver armarMandos).
           Ojo: esto apaga tambien el pellizco en el movil, y esta bien —
           alli el pellizco choca con el zoom de la propia pagina. */
        mv.setAttribute('disable-zoom', '');
        /* SIN auto-rotate (quitado el 21 sep 2026). Gabriel: "la imagen de
           la escena 3d se sigue pillando" — el giro automatico de
           model-viewer no es fluido en todos los equipos y se ve a
           tirones. El cuadro entra quieto, a la orientacion de
           camera-orbit de abajo, y solo gira si el visitante lo coge. */
        mv.setAttribute('interaction-prompt', 'none');
        mv.setAttribute('shadow-intensity', '1.2');
        mv.setAttribute('exposure',
          String(parseFloat((ajustes && ajustes.dataset.brillo) || '150') / 100));
        mv.setAttribute('camera-orbit', '-22deg 80deg ' + RADIO_INICIAL + '%');
        /* El 30 % de radio minimo es el mismo tope que usa el visor de la
           portada: mas cerca y el cuadro atraviesa el plano de la camara. */
        mv.setAttribute('min-camera-orbit', 'auto 40deg 30%');
        mv.setAttribute('max-camera-orbit', 'auto 110deg 200%');
        /* EAGER: en el carrusel del móvil esto se prepara con la diapositiva
           todavía fuera de la vista, y con el valor de siempre (lazy)
           model-viewer no abre el modelo hasta que la ve: volvía la espera. */
        mv.setAttribute('loading', 'eager');
        mv.addEventListener('load', function () {
          clearTimeout(relojCarga);
          caja.classList.add('esta-puesto');
        });
        mv.addEventListener('error', function (e) {
          if (caja.classList.contains('esta-puesto')) return;
          quitar(caja, 'el visor dio error (' + ((e.detail && e.detail.type) || '?') + ')');
        });
        caja.appendChild(mv);
        armarMandos();
        return pintar();
      })
      .catch(function (e) {
        quitar(caja, (e && e.message) || String(e));
      });

    /* Al cambiar de talla, el modelo de antes mide lo que no es. */
    ['change', 'variant:change'].forEach(function (ev) {
      seccion.addEventListener(ev, function () {
        if (api && mv) pintar();
      });
    });
  }

  /* Si no se puede montar, la diapositiva y su miniatura desaparecen: mejor
     una galería de tres fotos que una cuarta en blanco. */
  function quitar(caja, motivo) {
    if (window.console) console.warn('[3D de la ficha] no se monta:', motivo);
    if (DIAG) {
      caja.classList.add('no-va');
      var nota = document.createElement('p');
      nota.textContent = 'El 3D no se ha montado: ' + motivo;
      nota.style.cssText = 'position:absolute;inset:6rem 1.6rem auto;z-index:3;margin:0;padding:1rem;' +
        'background:#fff;color:#111;font:1.3rem/1.4 sans-serif;border-radius:0.6rem;';
      caja.appendChild(nota);
      return;
    }
    var diapo = caja.closest('.product__media-item');
    if (diapo) {
      var id = diapo.dataset.mediaId;
      diapo.remove();
      if (id) {
        var mini = document.querySelector('.thumbnail-list__item[data-target="' + id + '"]');
        if (mini) mini.remove();
      }
    }
  }

  /* El carrusel que contiene la diapositiva, si la galería es un carrusel
     ahora mismo (en el móvil sí; en el PC es una columna y no hay). */
  function carruselDe(caja) {
    for (var el = caja.parentElement; el && el !== document.body; el = el.parentElement) {
      var ox = getComputedStyle(el).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 1) return el;
    }
    return null;
  }

  /* Cuando la página ya ha bajado lo suyo: el 3D no le quita sitio a las
     fotos de arriba. El plazo es por si el 'load' se retrasa (las apps de
     Shopify a veces lo alargan mucho). */
  function trasLaCarga(fn) {
    var hecho = false;
    function una() {
      if (hecho) return;
      hecho = true;
      if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2000 });
      else setTimeout(fn, 500);
    }
    if (document.readyState === 'complete') return una();
    window.addEventListener('load', una, { once: true });
    setTimeout(una, 6000);
  }

  function arrancar() {
    document.querySelectorAll('[data-cs3d-galeria]').forEach(function (caja) {
      /* NO SE MONTA HASTA QUE SE VA A VER. En escritorio la galería va en
         columna y la diapositiva del 3D queda abajo del todo; en móvil es un
         carrusel y solo llega quien pasa hasta el final. */
      var ojo = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        ojo.disconnect();
        montar(caja);
      }, { rootMargin: '300px 0px' });
      ojo.observe(caja);

      /* EN UN CARRUSEL (el móvil) ESO LLEGA TARDE: la diapositiva está
         recortada por el carrusel y el observador no salta hasta que ya la
         estás mirando, con 3 s o más de recuadro vacío por delante. Así que
         ahí se prepara antes: en cuanto empiezas a deslizar, o cuando la
         página ha terminado de cargar con la galería a la vista. */
      var carrusel = carruselDe(caja);
      if (carrusel) {
        var yaVa = function () {
          ojo.disconnect();
          montar(caja);
        };
        carrusel.addEventListener('scroll', yaVa, { once: true, passive: true });
        var ojoGaleria = new IntersectionObserver(function (entradas) {
          if (!entradas[0].isIntersecting) return;
          ojoGaleria.disconnect();
          trasLaCarga(yaVa);
        }, { rootMargin: '300px 0px' });
        ojoGaleria.observe(carrusel);
      }

      /* En el carrusel del móvil la diapositiva existe fuera de la vista pero
         SÍ está en el viewport vertical, así que el observador se dispararía
         solo con eso. Este segundo enganche cubre el caso contrario: que el
         visitante pulse su miniatura antes de que el observador salte. */
      var diapo = caja.closest('.product__media-item');
      var id = diapo && diapo.dataset.mediaId;
      if (!id) return;
      var mini = document.querySelector('.thumbnail-list__item[data-target="' + id + '"]');
      if (mini) {
        mini.addEventListener('click', function () {
          ojo.disconnect();
          montar(caja);
        }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
